export default __webpack_public_path__ + "static/media/slide_6.e4891290.jpg";